import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'teamKey' | 'scheduledForDeletionAt'>;
};

export default function TeamKeyCell({
  rowData: { teamKey, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={teamKey}
    />
  );
}
